import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { AccountOverviewResponse } from './types';

type GetAccountProps = {
  artistId: string;
};

export const getAccount = async ({ artistId }: GetAccountProps) => {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/account`;

  const response = await api.executeGetRequest<ObjectResponse<AccountOverviewResponse>>(url);

  return response.data;
};
